export default "__VITE_ASSET__DdA7HNXS__"